import './components/row_filters_controller'
import './components/scrollable_container_controller'
import '../vendor/cookies';
import '../controllers/notification_controller'
import '../controllers/view_tour_controller';
import '../controllers/search_with_suggestions_date_controller'
import '../controllers/date_range_picker_controller'
import '../controllers/add_place_images_controller';
import '../controllers/add_place_suggested_places_controller';

import "bootstrap/dist/css/bootstrap.min.css"
import { Collapse, Dropdown, Alert, Modal } from "bootstrap"

window.bootstrap = { Collapse: Collapse, Dropdown: Dropdown, Alert: Alert, Modal: Modal }
